// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class RelatedItemsService {
   $http: any
   $timeout: any
   alerts: any
   api: any
   apiTimeout: any
   availability: any
   data: any
   indicators: any
   pageSize: any
   relatedItemsConfig: any
   scope: any
   startIndex: any
   types: any
   utils: any
   constructor(api: any, types: any, availability: any, $timeout: any, $http: any, i18n: any, data: any, config: any, alerts: any, utils: any) {
      this.reset = this.reset.bind(this)
      this.processNew = this.processNew.bind(this)
      this.getResultsFeedIndicators = this.getResultsFeedIndicators.bind(this)
      this.getIndicators = this.getIndicators.bind(this)
      this.getLookup = this.getLookup.bind(this)
      this.isActive = this.isActive.bind(this)
      this.selectType = this.selectType.bind(this)
      this.toggleRelatedItems = this.toggleRelatedItems.bind(this)
      this.getMore = this.getMore.bind(this)
      this.getRelatedItems = this.getRelatedItems.bind(this)
      this.callApi = this.callApi.bind(this)
      this.query = this.query.bind(this)
      this.responseProcessor = this.responseProcessor.bind(this)
      this.responseErrorProcessor = this.responseErrorProcessor.bind(this)
      this.servicesErrorProcessor = this.servicesErrorProcessor.bind(this)
      this.retry = this.retry.bind(this)
      this.api = api
      this.types = types
      this.availability = availability
      this.$timeout = $timeout
      this.$http = $http
      this.data = data
      this.alerts = alerts
      this.utils = utils
      this.relatedItemsConfig = config.data.relatedItems
      this.scope = {}
      this.pageSize = 10
      this.apiTimeout = 10000 // allow 10 secs for requests to API services
      this.reset(true)

      if (this.relatedItemsConfig.enabled) {
         this.data.on('new', this.processNew)
         this.data.on('update', this.getResultsFeedIndicators)
      }
   }

   reset(resetIndicators=false)  {
      if (resetIndicators) {
         this.indicators = {}
         this.startIndex = 0
      }
      return _.extend(this.scope, {
         reviews: {
            docs: [],
            count: Infinity,
            pn: 1,
            endOfResults: false,
            summonIds: [],
            exists: false
         },
         chapters: {
            docs: [],
            count: Infinity,
            pn: 1,
            endOfResults: false,
            summonIds: [],
            exists: false
         },
         loading: false,
         loadingError: false,
         gotLookup: false,
         currentDoc: null,
         type: null
      }
      )
   }

   processNew() {
      this.reset(true)
      return this.getResultsFeedIndicators()
   }

   getResultsFeedIndicators() {
      let docs = this.data.data.search.documents
      const docsLength = docs ? docs.length : 0

      // only look at the latest docs
      docs = docs ? docs.slice(this.startIndex) : []
      docs = _.filter(docs, (doc: any) => doc.content_type.match(/(book|ebook)/i))
      this.startIndex = docsLength
      // give time for browser to render results
      return this.$timeout((() => this.getIndicators(docs)), 50)
   }

   getIndicators(docs: any) {
      let doc
      const requestDocs = {docs: []}
      for (doc of docs) {
         var requestDoc = {id: doc.id}
         if (doc.participant_ids?.length) {
            const isbns: string[] = (doc.isbns ?? []).concat(doc.eisbns ?? []);
            if (isbns?.length) {
               // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
               requestDoc['isbns'] = isbns
               // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: any; }' is not assignable ... Remove this comment to see the full error message
               requestDocs.docs.push(requestDoc)
            }
         }
      }

      if (requestDocs.docs.length) {
         const promise = this.$http.post(`/2.0.0/services/relateditems/indicators/${this.relatedItemsConfig.libHash}`, requestDocs, { cache: true, timeout: this.apiTimeout })
         return promise
            .then((response: any) => {
               return (() => {
                  const result = []
                  for (doc of response?.data?.["doc.info"]) {
                     if (doc["BookChapter"] || doc["BookReview"]) {
                        var currDoc = (this.indicators[doc["docid"]] = {})
                        // @ts-expect-error TS(2339) FIXME: Property 'hasChapters' does not exist on type '{}'... Remove this comment to see the full error message
                        if (doc["BookChapter"]) { currDoc.hasChapters = doc["BookChapter"] }
                        // @ts-expect-error TS(2339) FIXME: Property 'hasReviews' does not exist on type '{}'.
                        if (doc["BookReview"]) { result.push(currDoc.hasReviews = doc["BookReview"]) } else {
                           result.push(undefined)
                        }
                     } else {
                        result.push(undefined)
                     }
                  }
                  return result
               })()
            })
            .catch(this.servicesErrorProcessor)
      }
   }

   getLookup() {
      const isbns: string[] = (this.scope.currentDoc.isbns ?? []).concat(this.scope.currentDoc.eisbns ?? [])
      let endpoint = `/2.0.0/services/relateditems/lookup?isbns=${isbns.join(',')}`

      const promise = this.$http.get(endpoint, {timeout: this.apiTimeout})
      return promise
         .then((response: any) => {
            this.scope.gotLookup = true
            if (response.data != null) {
               this.scope.reviews.summonIds = response.data["BookReview"] || []
               return this.scope.chapters.summonIds = response.data["BookChapter"] || []
            }
         })
         .catch(this.servicesErrorProcessor)
   }

   isActive(id: any) {
      return this.scope.currentDoc?.id === id
   }

   selectType(type: any) {
      if (this.scope.type === type) { return }
      this.scope.type = type
      this.scope.loadingError = false
      this.alerts.resetAlert('relatedItemsError')
      if (!this.scope[type].docs.length) { return this.getRelatedItems(this.scope.currentDoc, type) }
   }

   toggleRelatedItems(doc: any) {
      const isActive = this.isActive(doc.id)
      this.reset()
      if (isActive) { return }

      const currIndicator = this.indicators[doc.id]
      this.scope[this.types.REVIEWS].exists = currIndicator.hasReviews
      this.scope[this.types.CHAPTERS].exists = currIndicator.hasChapters

      // set the type based off of existence
      const type = currIndicator.hasReviews ? this.types.REVIEWS : this.types.CHAPTERS
      return this.getRelatedItems(doc, type)
   }

   getMore() {
      return this.getRelatedItems(this.scope.currentDoc, this.scope.type)
   }

   getRelatedItems(doc: any, type: any) {
      this.alerts.resetAlert('relatedItemsError')

      if (this.scope.currentDoc !== doc) { this.scope.currentDoc = doc }
      if (this.scope.type !== type) { this.scope.type = type }

      this.scope.loading = true

      if (this.scope.gotLookup) {
         return this.callApi()
      } else {
         return this.getLookup()
            .then(this.callApi)
            .catch(this.responseErrorProcessor)
            .finally(() => { return this.scope.loading = false })
      }
   }

   callApi() {
      const doc = this.scope.currentDoc
      const {
         type
      } = this.scope
      return this.api.relatedItems(this.query())
         .then(this.responseProcessor(doc, type))
         .catch(this.responseErrorProcessor)
         .finally(() => { return this.scope.loading = false })
   }

   query() {
      const {
         type
      } = this.scope
      if (!this.scope[type].summonIds.length) {
         this.responseErrorProcessor()
         this.scope.gotLookup = false
         this.scope.loading = false
         throw new Error("Empty Summon IDs")
      }
      return {
         ri: this.scope[type].summonIds,
         pn: this.scope[type].pn,
         ps: this.pageSize,
         ho: false
      }
   }

   responseProcessor(doc: any, type: any) {
      return (response: any) => {
      // The doc changed by a new search or another one was clicked -- prevent processing old call.
         if ((this.scope.currentDoc === null) || (this.scope.currentDoc.id !== doc.id)) { return }
         const typeScope = this.scope[type]

         if (response.data?.documents != null) {
            const docs = response.data.documents
            this.availability.getRTA(docs)
            _.each(docs, (doc: any) => {
               // HACK: prevent dupes in result set -- related to match/merge issue during assembly - SUM-95601
               if (_.pluck(typeScope.docs, 'id').indexOf(doc.id) <= -1) { return typeScope.docs.push(doc) }
            })

            typeScope.count = response.data.record_count
            if ((typeScope.count <= typeScope.docs.length) || !docs.length) {
               return typeScope.endOfResults = true
            } else {
               return typeScope.pn++
            }
         } else {
            if (typeScope.count === Infinity) { return typeScope.count = 0 }
         }
      }
   }

   responseErrorProcessor() {
      this.scope.loadingError = true
      return this.alerts.setAlert('relatedItemsError', `${this.utils.titleCase(this.scope.type)} failed to load.`)
   }

   servicesErrorProcessor(error: any) {
      if (error.status < 0) {
         // eslint-disable-next-line no-console
         console.error(`Call to ${error.config.url} timed out!`)
      } else if (error.status) {
         // eslint-disable-next-line no-console
         console.error(`${error.status}: ${error.statusText}`)
      } else { 
         // eslint-disable-next-line no-console
         console.error(error.message)
      }
   }

   retry() {
      this.scope.loadingError = false
      return this.getMore()
   }
}

RelatedItemsService.$inject = ['apiService', '$relatedItemTypes', 'availabilityService', '$timeout', '$http', 'translationService', 'dataService', 'configService', 'alertService', 'utilitiesService']

angular.module('summonApp.services')
   .service('relatedItemsService', RelatedItemsService)
